
import { defineComponent, toRaw } from "vue"
import { mapGetters } from "vuex"
import { photosByYear } from "@/utils/gallery"

export default defineComponent({
  validate ({ route: { params: { year } } }) {
    return year in photosByYear
  },

  data () {
    return {
      photos: toRaw(photosByYear[this.$route.params.year]),
    }
  },

  head () {
    const { year } = this.$route.params

    return {
      title: this.getTitle(`Фотогалерея ${year}`),
    }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),
  },
})
